import { FormikContextType } from 'formik';
import { TDocSeries } from 'shared/constants/docs';
import { styled } from '@mui/material';
import S3img from 'shared/components/S3img/S3img';
import DropZone from 'shared/_ui/drop-zone';
import { useCallback } from 'react';

const SeriesImageContainer = styled('div', { name: 'SeriesImageContainer' })(({ theme }) => ({
	borderRadius: theme.spacing(2),
	position: 'relative',
	aspectRatio: '16 / 9',
	overflow: 'hidden',
	display: 'flex',
	flexBasis: theme.spacing(40),
	flexShrink: 0,
	height: 'max-content',
}));

export default function SeriesImage({
	formik,
	isEdit,
}: {
	formik: FormikContextType<TDocSeries>;
	isEdit: boolean;
}) {
	const handleDrop = useCallback(
		(files: FileList) => {
			const file = [...files][0];
			formik.setFieldValue('image', file);
		},
		[formik]
	);

	const src = (formik.values as any).thumbnail?.cloud?.s3 || formik.values.image;

	return (
		<SeriesImageContainer>
			<S3img src={src} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
			{isEdit && (
				<DropZone
					sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
					size="small"
					onDrop={handleDrop}
				/>
			)}
		</SeriesImageContainer>
	);
}
